// The aggregate Score Inputs reviews give a File. Since ADR-0109 there is one:
// the Customer Harm Rate over the Company's `in_scope` reviews and BBB
// complaints. The derived comparison views read the same labels but are never
// Score Inputs.
export enum ReviewMeasurementKey {
  CUSTOMER_HARM_RATE = "customer_harm_rate",
}
